export enum ErrorLevel {
     Error,
     Information,
     Warning,
     Success
}